export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16">
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">Legal</span>
      <h1 className="font-anton text-5xl md:text-6xl uppercase tracking-tight mt-3 leading-none" data-testid="privacy-title">
        Privacy Policy
      </h1>
      <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground mt-4">
        Effective date: June 2026 · nerosunmedia.com
      </p>

      <div className="space-y-5 mt-10 text-foreground/85 text-base leading-relaxed">
        <p>
          This Privacy Policy describes how NERO SUN ("we", "us") collects, uses and shares
          information when you visit nerosunmedia.com (the "Site"). By using the Site you agree to
          the practices described here.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Information We Collect</h2>
        <p>
          We collect information you voluntarily provide through our forms — such as your name,
          email address, company and message when you submit an advertiser inquiry or contact us.
          We also automatically collect standard technical data (such as IP address, browser type,
          device information and pages visited) through cookies and similar technologies.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">How We Use Information</h2>
        <p>
          We use the information to operate and improve the Site, respond to inquiries, deliver and
          measure advertising, and communicate with you about partnerships you request.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Cookies & Advertising</h2>
        <p>
          We use cookies to run the Site and to serve advertising. Third-party vendors, including
          Google, use cookies to serve ads based on your prior visits to this and other websites.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Google's use of advertising cookies enables it and its partners to serve ads to you
            based on your visit to this Site and/or other sites on the Internet.
          </li>
          <li>
            You may opt out of personalized advertising by visiting{" "}
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-signal hover:underline">Google Ads Settings</a>.
          </li>
          <li>
            You can opt out of third-party vendor cookies for personalized advertising at{" "}
            <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer" className="text-signal hover:underline">www.aboutads.info</a>.
          </li>
        </ul>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Third-Party Services</h2>
        <p>
          We rely on third-party processors to operate the Site, including Google AdSense
          (advertising) and Resend (transactional email). These providers process data on our behalf
          in accordance with their own privacy policies.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Data Retention</h2>
        <p>
          We retain inquiry and contact information for as long as necessary to respond to and manage
          partnership requests, and as required by law.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Your Rights</h2>
        <p>
          Depending on your location, you may have the right to access, correct or delete your
          personal information. To make a request, email us at{" "}
          <a href="mailto:peartmedia@gmail.com" className="text-signal hover:underline">peartmedia@gmail.com</a>.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Children's Privacy</h2>
        <p>The Site is not directed to children under 13, and we do not knowingly collect their data.</p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Changes</h2>
        <p>
          We may update this policy from time to time. Continued use of the Site after changes
          constitutes acceptance of the revised policy.
        </p>

        <h2 className="font-anton text-xl uppercase tracking-tight pt-4">Contact</h2>
        <p>
          For any privacy questions, contact{" "}
          <a href="mailto:peartmedia@gmail.com" className="text-signal hover:underline">peartmedia@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}
